import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getItemWithExpiry,
  hasRoles,
  removeItemWithExpiry,
  setItemWithExpiry,
} from "../../lib/utility";
import axios from "../../redux/axios";

const initialState = {
  getProfile: globalThis.profileData ?? {},
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  profileUpdate: {},

  isFetchingProfileUpdate: false,
  isSuccessProfileUpdate: false,
  isErrorProfileUpdate: false,
  isErrorMessageProfileUpdate: "",

  isFetchingApiKey: false,
  isSuccessApiKey: false,
  isErrorApiKey: false,
  errorMessageApiKey: "",

  getalert: {},
  isFetchingAlert: false,
  isSuccessAlert: false,
  isErrorAlert: false,
  errorMessageAlert: "",
};

export const getProfileData = createAsyncThunk(
  "login/user/data",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let user = auth.user;
      const isSellerManager = hasRoles("seller,manager", user);

      const profileData = getItemWithExpiry("profileData");

      if (profileData) {
        if (
          typeof profileData.provCode === "string" &&
          (profileData.provCode.includes(" ") ||
            profileData.provCode.toLowerCase().includes("email") ||
            profileData.provCode.toLowerCase().includes("sent"))
        ) {
          removeItemWithExpiry("profileData");
        } else {
          return { ...profileData, status: 200 };
        }
      }

      let tokenStr = auth.user.accessToken;
      let { data, status } = await axios.get(
        isSellerManager
          ? `/sales/view-sales-entry/` + auth.user.id
          : `/login/user/data`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      if (status.toString().startsWith("2")) {
        const pData = isSellerManager
          ? {
              ...data["seller"],
              profileName: data.profileName,
              profilePath: data.profilePath,
              status,
            }
          : { ...data, status };

        if (
          typeof pData.provCode === "string" &&
          (pData.provCode.includes(" ") ||
            pData.provCode.toLowerCase().includes("email") ||
            pData.provCode.toLowerCase().includes("sent"))
        ) {
          pData.provCode = "";
        }

        setItemWithExpiry("profileData", pData, 10800);
        return pData;
      } else {
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
export const userProfileUpdate = createAsyncThunk(
  "login/updateProfile",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { editableFields, selectedFile } = udata;
      const formData = new FormData();

      for (const key in editableFields) {
        if (
          Object.prototype.hasOwnProperty.call(editableFields, key) &&
          editableFields[key] !== undefined &&
          editableFields[key] !== null &&
          (editableFields[key] !== "" || editableFields[key] !== 0)
        ) {
          formData.append(key, editableFields[key]);
        }
      }

      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      if (hasRoles("seller,manager", auth.user)) {
        formData.append("id", auth.user.id);
      }

      const { data, status } = await axios.put(
        hasRoles("seller,manager", auth.user)
          ? `/sales/update`
          : `/login/updateProfile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status.toString().startsWith("2")) {
        if (typeof data === "string") {
          return { message: data.trim(), status };
        }
        return { ...data, status };
      } else {
        return thunkAPI.rejectWithValue({ ...data, status });
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const regenerateApiKey = createAsyncThunk(
  "login/changeApiKey",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth?.user?.accessToken;
      const username =
        udata?.userName ||
        auth?.user?.userName ||
        auth?.user?.username ||
        "";
      const headers = {
        username: username,
      };
      if (tokenStr) {
        headers.Authorization = `Bearer ${tokenStr}`;
      }
      const { data, status } = await axios.get("/login/changeApiKey", {
        headers,
      });
      if (status.toString().startsWith("2")) {
        const msg =
          (typeof data === "string" && data.trim()) ||
          (typeof data?.message === "string" && data.message.trim()) ||
          (typeof data?.msg === "string" && data.msg.trim()) ||
          (typeof data?.data === "string" && data.data.trim()) ||
          "";
        return {
          message: msg,
          status,
        };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    updateUserData: (state, action) => {
      (state.getProfile.displaySmscId = action.payload.displaySmscId),
        (state.getProfile.replacedSenderId = action.payload.replacedSenderId);
    },
    clearStateProfile: (state, { payload }) => {
      state.getProfile = {};
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
      state.isFetchingApiKey = false;
      state.isSuccessApiKey = false;
      state.isErrorApiKey = false;
      state.errorMessageApiKey = "";
    },
    clearStateProfileUpdateData: (state, { payload }) => {
      state.profileUpdate = {};
      state.isFetching = false;
      state.isSuccessProfileUpdate = false;
      state.isErrorProfileUpdate = false;
      state.isErrorMessageProfileUpdate = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileData.fulfilled, (state, action) => {
        state.getProfile = action.payload;
        state.isFetching = false;
        state.isSuccess = true;
        state.errorMessage = action.payload;
      })
      .addCase(getProfileData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getProfileData.rejected, (state, action) => {
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })

      
      .addCase(userProfileUpdate.fulfilled, (state, action) => {
        state.profileUpdate = action.payload.data;
        state.isFetchingProfileUpdate = false;
        state.isSuccessProfileUpdate = true;
        state.isErrorMessageProfileUpdate = action.payload.data;
        removeItemWithExpiry("profileData");
      })
      .addCase(userProfileUpdate.pending, (state) => {
        state.isFetchingProfileUpdate = true;
        state.isErrorMessageProfileUpdate = "";
        state.isErrorProfileUpdate = false;
      })
      .addCase(userProfileUpdate.rejected, (state, action) => {
        state.isFetchingProfileUpdate = false;
        state.isErrorProfileUpdate = true;
        state.errorMessageProfileUpdate = action.payload
          ? action.payload.message
          : "Internal error";
      })

      .addCase(regenerateApiKey.pending, (state) => {
        state.isFetchingApiKey = true;
        state.isSuccessApiKey = false;
        state.isErrorApiKey = false;
        state.errorMessageApiKey = "";
      })
      .addCase(regenerateApiKey.fulfilled, (state, action) => {
        state.isFetchingApiKey = false;
        state.isSuccessApiKey = true;
        state.isErrorApiKey = false;
        state.errorMessageApiKey = "";
      })
      .addCase(regenerateApiKey.rejected, (state, action) => {
        state.isFetchingApiKey = false;
        state.isErrorApiKey = true;
        state.errorMessageApiKey =
          (typeof action.payload === "string" ? action.payload : null) ||
          action.payload?.message ||
          action.payload?.data?.message ||
          action.payload?.data ||
          "Failed to regenerate API key";
      });

   
  },
});

export const {
  clearStateProfile,
  clearStateProfileUpdateData,
  updateUserData,
} = profileSlice.actions;

export function clearState() {
  return async (dispatch) => {
    dispatch(clearStateProfile());
  };
}
export function clearStateProfileUpdate() {
  return async (dispatch) => {
    dispatch(clearStateProfileUpdateData());
  };
}

export const profileSelector = (state) => state.profile;

export default profileSlice.reducer;
